import { z } from 'zod';
import { apiGet } from '../client';
import { MerchantReadinessSchema, type MerchantProviderSchema } from '../schemas';

const ResponseSchema = z.object({ data: MerchantReadinessSchema });
export function getMerchantReadiness(provider: z.infer<typeof MerchantProviderSchema>) {
  return apiGet(`/v1/business/payment-readiness/${encodeURIComponent(provider)}`, ResponseSchema).then(response => response.data);
}
